<template>
    <!-- Só aparece quando a loja oferece mais de um idioma: a loja de um idioma só não muda nada. -->
    <v-menu v-if="idiomas.length > 1" offset-y left>
        <template #activator="{ on, attrs }">
            <v-btn
                text
                small
                class="px-1"
                :color="cor"
                :aria-label="$t('geral.idioma')"
                v-bind="attrs"
                v-on="on"
            >
                <v-icon small class="mr-1">mdi-translate</v-icon>
                {{ sigla(idioma) }}
            </v-btn>
        </template>

        <v-list dense>
            <v-list-item
                v-for="item in idiomas"
                :key="item"
                :input-value="item === idioma"
                @click="escolherIdioma(item)"
            >
                <v-list-item-title>{{ nome(item) }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { IDIOMAS, idiomasDaLoja } from '@/i18n';

export default {
    name: 'SeletorIdioma',

    props: {
        cor: { type: String, default: undefined },
    },

    computed: {
        ...mapState(['configuracoes', 'idioma']),

        idiomas() {
            return idiomasDaLoja(this.configuracoes);
        },
    },

    methods: {
        ...mapActions(['escolherIdioma']),

        nome(idioma) {
            return IDIOMAS[idioma]?.nome || idioma;
        },

        sigla(idioma) {
            return String(idioma || '').slice(0, 2).toUpperCase();
        },
    },
};
</script>
